import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemIcon,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { useUserProductAccess } from "./hooks/useUserProductAccess";

export default function ProductDropDown({ value, onChange, label = "Product" }) {
  const { isLoading, productRoles: products } = useUserProductAccess();

  const getColorFromHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return `hsl(${hash % 360}, 60%, 50%)`;
  };

  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <FormControl fullWidth sx={{ backgroundColor: "white" }}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        renderValue={(selected) => {
          const selectedProductObj = products.find((p) => p.id === selected);
          const color = selectedProductObj
            ? getColorFromHash(selectedProductObj.id)
            : "#ccc";
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <DescriptionIcon style={{ color, fontSize: 24 }} />
              {selectedProductObj?.title}
            </div>
          );
        }}
      >
        {products.map((product) => {
          const color = getColorFromHash(product.id);
          return (
            <MenuItem key={product.id} value={product.id}>
              <ListItemIcon>
                <DescriptionIcon style={{ color, fontSize: 24 }} />
              </ListItemIcon>
              <ListItemText primary={product.title} />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
